// extracted by mini-css-extract-plugin
export default {"multiSelectTempFix":"LabeledMultiSelect__multiSelectTempFix--VsTVsEPeevIASOM2XnwX"};